import {EnvironmentProvider} from 'providers/EnvironmentProvider'
import {get} from 'lodash'

type Props = {
  configKey: string
  defaultText: string
}

export const ConfigText = ({configKey, defaultText}: Props) => {
  const variations = EnvironmentProvider.useVariations()
  const text = get(variations, `widgets.${configKey}.text`, defaultText)
  return <>{text}</>
}
